export class Modals {
  public static readonly CompanyComponent: string = 'CompanyComponent';
  public static readonly CompanyBankComponent: string = 'CompanyBankComponent';
  public static readonly SendEmailMessageComponent: string = 'SendEmailMessageComponent';
  public static readonly EmailMessageDetailsComponent: string = 'EmailMessageDetailsComponent';
  public static readonly FinancialTransactionDetailsComponent: string = 'FinancialTransactionDetailsComponent';
  public static readonly ModuleComponent: string = 'ModuleComponent';
  public static readonly ModuleDetailsComponent: string = 'ModuleDetailsComponent';
  public static readonly PaymentActionComponent: string = 'PaymentActionComponent';
  public static readonly PaymentActionsUrlComponent: string = 'PaymentActionsUrlComponent';
  public static readonly PaymentRequestComponent: string = 'PaymentRequestComponent';
  public static readonly PaymentRequestInformationComponent: string = 'PaymentRequestInformationComponent';
  public static readonly PaymentRequestUrlComponent: string = 'PaymentRequestUrlComponent';
  public static readonly SendSmsMessageComponent: string = 'SendSmsMessageComponent';
  public static readonly SmsMessageDetailsComponent: string = 'SmsMessageDetailsComponent';
  public static readonly UserComponent: string = 'UserComponent';
  public static readonly UserPreSharedKeyComponent: string = 'UserPreSharedKeyComponent';
  public static readonly DocumentIntelligenceModelComponent: string = "ModelComponent";
}
